import { CdkStepperNext } from '@angular/cdk/stepper';
import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[muiWizardNext]'
})
export class MuiWizardNextDirective extends CdkStepperNext {

  @Input()
  @HostBinding('attr.type')
  type: 'button' | 'submit' = 'button';

  @HostBinding('class.mui-wizard-next')
  readonly _muiBaseClass = true;
}
